// Parse media source into a sandbox-friendly playable spec.
// For embed URLs, normalize YouTube/Vimeo to their official player URLs so we
// can apply strict params (no related, no title bar where supported).

export function parseSource(media) {
  if (!media) return null;
  if (media.sourceType === "direct") {
    return { kind: "direct", src: media.sourceUrl };
  }
  const url = (media.sourceUrl || "").trim();
  const yt = extractYouTubeId(url);
  if (yt) {
    const params = new URLSearchParams({
      autoplay: "1",
      rel: "0",
      playsinline: "1",
      iv_load_policy: "3",
      enablejsapi: "1",
    });
    return {
      kind: "youtube",
      src: `https://www.youtube-nocookie.com/embed/${yt}?${params.toString()}`,
    };
  }
  const vimeo = extractVimeoId(url);
  if (vimeo) {
    const params = new URLSearchParams({
      autoplay: "1",
      dnt: "1",
      title: "0",
      byline: "0",
      portrait: "0",
    });
    if (vimeo.hash) params.set("h", vimeo.hash);
    return {
      kind: "vimeo",
      src: `https://player.vimeo.com/video/${vimeo.id}?${params.toString()}`,
    };
  }
  return { kind: "embed", src: url };
}

const YT_ID_RE = /^[a-zA-Z0-9_-]{11}$/;

function extractYouTubeId(url) {
  try {
    const u = new URL(url);
    const validate = (id) => (id && YT_ID_RE.test(id) ? id : null);
    if (u.hostname === "youtu.be") {
      return validate(u.pathname.slice(1).split("/")[0]);
    }
    if (
      u.hostname.endsWith("youtube.com") ||
      u.hostname.endsWith("youtube-nocookie.com")
    ) {
      if (u.pathname === "/watch") return validate(u.searchParams.get("v"));
      const parts = u.pathname.split("/").filter(Boolean);
      if (["embed", "shorts", "v"].includes(parts[0])) return validate(parts[1]);
    }
  } catch {
    return null;
  }
  return null;
}

export { extractYouTubeId };

function extractVimeoId(url) {
  try {
    const u = new URL(url);
    if (u.hostname.endsWith("vimeo.com") || u.hostname === "player.vimeo.com") {
      const parts = u.pathname.split("/").filter(Boolean);
      for (let i = 0; i < parts.length; i++) {
        if (/^\d+$/.test(parts[i])) {
          // The next path segment (if non-numeric) is the private hash
          const hash = parts[i + 1] && !/^\d+$/.test(parts[i + 1]) ? parts[i + 1] : null;
          return { id: parts[i], hash };
        }
      }
    }
  } catch {
    return null;
  }
  return null;
}
